export enum CASE_TYPE {
  INDIVIDUAL = 'INDIVIDUAL_OR_MULTIPLE',
  COMPANY = 'COMPANY',
}
